import { Button } from '@chakra-ui/react';
import { SentryError } from '@ifixit/sentry';
import TrashButton from './trash_button';

export const ActionButton = ({
   action,
   rowIdx,
   deleteRow,
   addRow,
   trashDisabled = false,
   addDisabled = false,
}: {
   action: string;
   rowIdx: number;
   deleteRow: (idx: number) => void;
   addRow: () => void;
   trashDisabled?: boolean;
   addDisabled?: boolean;
}) => {
   switch (action) {
      case 'delete': {
         return <TrashButton onClick={() => deleteRow(rowIdx)} isDisabled={trashDisabled} />;
      }
      case 'add': {
         return (
            <Button onClick={() => addRow()} isDisabled={addDisabled}>
               Add
            </Button>
         );
      }
      default: {
         throw new SentryError(action);
      }
   }
};
